import React, { useEffect, useState } from 'react';
import { 
  CarrouselContainer, 
  CarrouselContent, 
  CarrouselModal,
  CarrouselHeader,
  CarrouselBody,
  CarrouselFooter,
  CarrouselUserInfo,
  CarrouselBodyText,
  CarrouselBodyStepsContent,
  CarrouselBodyStep,
  CarrouselButton,
  CarrouselImage
 } from './styles';
 import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const WelcomeSlider = ({ setShow, steps, header }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [stepToFade, setStepToFade] = useState(0);
  const [fade, setFade] = useState(true);

  function changeStep(key) {
    setActiveStep(key);
    setFade(false);

    setTimeout(() => {
      setStepToFade(key)
      setFade(true);
    }, 200)
  }

  return (
    <CarrouselContainer>
      <CarrouselContent>
        <CarrouselModal>
          <CarrouselHeader>
            <IoClose size={26} color={colors.textSecondary} onClick={() => setShow(false)}/>
          </CarrouselHeader>
          <CarrouselBody>
            <CarrouselUserInfo>{header}</CarrouselUserInfo>
            <CarrouselImage src={steps[stepToFade].image} alt="multidevice" show={fade} />
            <CarrouselBodyText show={fade}>
              {steps[stepToFade].description}
            </CarrouselBodyText>
            <CarrouselBodyStepsContent>
              {steps.map((step, key) => (
                <CarrouselBodyStep key={key} active={key === activeStep} onClick={() => changeStep(key)} />
              ))}
            </CarrouselBodyStepsContent>
          </CarrouselBody>
          <CarrouselFooter>
            <CarrouselButton onClick={() => setShow(false)}>Saltar</CarrouselButton>
          </CarrouselFooter>
        </CarrouselModal>
      </CarrouselContent>
    </CarrouselContainer>
  )
}

export default WelcomeSlider;
